//配置全局访问接口地址
let commonUrl = "https://eklc.lh9988.vip";
// let commonUrl = "https://ce579.cjendx.com/";
// let commonUrl = "/api";
 
let baseUrl = {
    commonUrl
}
 
export default baseUrl